import { useEffect, useRef, useState } from "react";

import { useNavigate } from "react-router-dom";
import SideBar from "../Sidebar";
import axios from "axios";
import { getBackendUrl } from "../../constants";
import ReactModal from "react-modal";
import { Controller, useFieldArray, useForm } from "react-hook-form";
import CustomSelect from "../CustomSelect/Index";
import Calender from "../Calender";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import DataTable from "../DataTable/Index";

// User Name
const userName = localStorage.getItem("user_name");

const BulkUpdateModal = ({ onCancel, onSubmit }) => {
  const { control, handleSubmit, watch } = useForm({
    defaultValues: { fields: [{}] },
  });
  const { fields, append, remove } = useFieldArray({ control, name: "fields" });
  return (
    <ReactModal
      isOpen={true}
      onRequestClose={onCancel}
      style={{
        content: {
          width: 500,
          background: "white",
          inset: "10% 0% 10% 50%",
          transform: "translateX(-50%)",
        },
        overlay: { zIndex: 2 },
      }}
    >
      {fields.map((field, index) => {
        const fieldValue = watch(`fields.${index}.field`);
        return (
          <div
            key={field.id}
            style={{
              display: "flex",
              marginBottom: 16,
              alignItems: "flex-end",
            }}
          >
            <Controller
              name={`fields.${index}.field`}
              control={control}
              render={({ field: { onChange, value } }) => {
                return (
                  <div style={{ marginRight: 16, width: "40%" }}>
                    <p className="text-[16px] text-black py-2 font-bold">
                      Field
                    </p>
                    <CustomSelect
                      value={value}
                      onChange={onChange}
                      options={[
                        {
                          label: "Payment Alert Date",
                          value: "payment_alert_date",
                        },
                        { label: "Freeze Date", value: "freeze_date" },
                        { label: "Terminate Date", value: "terminate_date" },
                        {
                          label: "OrderBook Enabled",
                          value: "orderbook_enabled",
                        },
                      ]}
                    />
                  </div>
                );
              }}
            />
            <Controller
              name={`fields.${index}.value`}
              control={control}
              render={({ field: { onChange, value } }) => {
                return (
                  <>
                    {fieldValue === "orderbook_enabled" ? (
                      <div
                        style={{ marginTop: 16, marginRight: 16, width: "40%" }}
                      >
                        <p className="text-[16px] text-black py-2 font-bold">
                          OrderedBook Enabled
                        </p>
                        <CustomSelect
                          value={value}
                          onChange={onChange}
                          options={[
                            { label: "No", value: false },
                            { label: "Yes", value: true },
                          ]}
                        />
                      </div>
                    ) : (
                      <div style={{ marginRight: 16 }}>
                        <p className="text-[16px] py-2 text-black font-bold">
                          Value
                        </p>
                        <Calender value={value} onChange={onChange} />
                      </div>
                    )}
                  </>
                );
              }}
            />
            <button
              style={{ border: "1px solid #ddd", padding: 8, borderRadius: 8 }}
              type="button"
              onClick={() => remove(index)}
            >
              Remove
            </button>
          </div>
        );
      })}
      <button
        type="button"
        style={{ border: "1px solid #ddd", padding: 8, borderRadius: 8 }}
        onClick={() => append({})}
      >
        Add Field
      </button>

      <div style={{ marginTop: 16 }}>
        <button
          className="bg-[#34B3ED] text-white font-bold py-2 px-10 rounded-full"
          onClick={handleSubmit(onSubmit)}
        >
          Update
        </button>
      </div>
    </ReactModal>
  );
};

function CompaniesList() {
  const gridApi = useRef();
  const [bulkUpdateModalVisible, setBulkUpdateModalVisible] = useState(false);
  // by this code we can stop user to go to login page if already logged

  useEffect(() => {
    const jwtToken = localStorage.getItem("Session_Id");
    if (jwtToken) {
    } else {
      navigate("/");
    }
  }, []);

  //till here

  const SESSION_ID = localStorage.getItem("Session_Id");

  const loadData = async () => {
    try {
      const response = await axios.get(
        `${getBackendUrl()}/v1/admin-portal/getCompanies`,
        { headers: { "Session-Id": SESSION_ID } }
      );
      setRowData(response.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    loadData();
  }, []);

  const [rowData, setRowData] = useState();

  const navigate = useNavigate();

  //define colums which we wants to display on screen
  const [columnDefs, setColumnDefs] = useState([
    {
      field: "id",
      headerName: "Company ID",
      filter: true,
      floatingFilter: true,
    },
    {
      field: "name",
      headerName: "Company Name",
      filter: true,
      floatingFilter: true,
    },
    {
      field: "customer_name",
      headerName: "Customer Name",
      filter: true,
      floatingFilter: true,
    },
    {
      field: "gst_no",
      headerName: "GST Number",
      filter: true,
      floatingFilter: true,
    },
    {
      field: "industry",
      headerName: "Industry ",
      filter: true,
      floatingFilter: true,
      tooltipField: "name",
      width: 140,
    },
    {
      field: "created_at",
      headerName: "Created Date",
      valueFormatter: (cell) =>
        cell.value ? new Date(cell.value).toLocaleDateString() : null,
      filter: true,
      floatingFilter: true,
      tooltipField: "name",
      width: 150,
    },
    {
      field: "payment_alert_date",
      headerName: "Payment Alert Date",
      filter: true,
      floatingFilter: true,
      valueFormatter: (cell) =>
        cell.value ? new Date(cell.value).toLocaleDateString() : null,
    },
    {
      field: "freeze_date",
      headerName: "Freeze Date",
      filter: true,
      floatingFilter: true,
      valueFormatter: (cell) =>
        cell.value ? new Date(cell.value).toLocaleDateString() : null,
    },
    {
      field: "terminate_date",
      headerName: "Terminate Date",
      filter: true,
      floatingFilter: true,
      valueFormatter: (cell) =>
        cell.value ? new Date(cell.value).toLocaleDateString() : null,
    },
    {
      field: "orderbook_enabled",
      headerName: "Orderbook Status",
      filter: true,
      floatingFilter: true,
      cellRenderer: (params) => {
        return params.data.id ? (params.value ? "YES" : "NO") : null;
      },
    },
    {
      field: "Actions",
      pinned: "right",
      width: 85,
      flex: 1,
      cellRenderer: (props) => {
        if (props.data.id) {
          return (
            <button
              className="inline-flex my-2 w-[50px] items-center justify-center px-2 py-4 font-sans font-semibold tracking-wide text-white bg-stone-800 hover:bg-stone-700  h-[30px]"
              style={{
                margin: "4px",
                borderRadius: "5px",
                alignItems: "center",
              }}
              onClick={() => navigate("/CompanyData", { state: props.data })}
            >
              EDIT
            </button>
          );
        } else {
          return null;
        }
      },
    },
  ]);

  //export data to csv in AgGrid
  const onGridReady = (params) => {
    gridApi.current = params.api;
  };

  const onExportClick = () => {
    gridApi.current.exportDataAsCsv();
  };

  //  company list Manage column visibility state
  const [columnsVisibilityCompany, setColumnsVisibilityCompany] = useState({
    id: true,
    name: true,
    gst_no: true,
    industry: true,
    created_at: true,
    payment_alert_date: true,
    freeze_date: true,
    terminate_date: true,
    orderbook_enabled: true,
    customer_name: true,
    Actions: true,
  });

  // compnay list Filter visible columns based on checkbox state
  const visibleColumnsCompany = columnDefs.filter(
    (col) => columnsVisibilityCompany[col.field]
  );

  //  company list Manage sidebar visibility state
  const [isSidebarVisibleCustomer, setSidebarVisibleCustomer] = useState(false);

  // company list Handle checkbox change to toggle column visibility
  const handleCheckboxChangeCompany = (column) => {
    setColumnsVisibilityCompany({
      ...columnsVisibilityCompany,
      [column]: !columnsVisibilityCompany[column],
    });
  };

  // companyList Toggle sidebar visibility
  const toggleSidebarCompany = () => {
    setSidebarVisibleCustomer(!isSidebarVisibleCustomer);
  };

  const handleBulkUpdate = async (data) => {
    const selectedIds = gridApi.current
      .getSelectedNodes()
      .map((obj) => obj.data.id);
    try {
      const response = await axios.post(
        `${getBackendUrl()}/v1/admin-portal/bulkUpdateCompanies`,
        { ...data, ids: selectedIds },
        { headers: { "Session-Id": SESSION_ID } }
      );
      if (response.status === 200) {
        loadData();
        toast.success("Updated companies successfully");
        setBulkUpdateModalVisible(false);
      }
    } catch (error) {
      toast.error("Bulk Update failed");
    }
  };

  return (
    <>
      <SideBar />
      <div
        style={{
          marginLeft: 240,
          height: "100vh",
          display: "flex",
          flexDirection: "column",
          padding: 16,
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            lineHeight: "1.5",
          }}
        >
          <div>
            <p style={{ fontSize: "25px", fontWeight: 700 }}>Companies List</p>
            <p style={{ color: "#919191" }}>Welcome {userName}</p>
          </div>
          <div style={{ display: "flex" }}>
            <button
              className=" m-2 w-[140px] h-[30px] mt-2 text-white bg-stone-800 hover:bg-stone-700 rounded-md "
              onClick={() => setBulkUpdateModalVisible(true)}
            >
              Bulk Update
            </button>
            <button
              className=" m-2 w-[140px] h-[30px] mt-2 text-white bg-stone-800 hover:bg-stone-700 rounded-md "
              onClick={() => onExportClick()}
            >
              Export to Excel
            </button>
          </div>
        </div>
        <button
          id="viewHideButton"
          onClick={toggleSidebarCompany}
          title="Hide & Show Columns"
          style={{
            position: "absolute",

            right: isSidebarVisibleCustomer ? "200px" : "10px",
            zIndex: 1,
          }}
        >
          {isSidebarVisibleCustomer ? (
            <i className="bi bi-arrow-right-circle-fill text-[#00A0E3]"></i>
          ) : (
            <i className="bi bi-layout-sidebar-inset-reverse   text-[#00A0E3]"></i>
          )}
        </button>
        <div
          style={{
            width: isSidebarVisibleCustomer ? "170px" : "0",
            transition: "width 0.3s ease",
            overflow: "hidden",
            float: "right",
            padding: isSidebarVisibleCustomer ? "20px" : "0",
            borderLeft: isSidebarVisibleCustomer ? "1px solid #ccc" : "none",
            backgroundColor: "#000000",
            color: "white",
            position: "relative",
          }}
        >
          {isSidebarVisibleCustomer && (
            <>
              <h3>Show/Hide Columns</h3>
              <label>
                <input
                  className="mr-2"
                  type="checkbox"
                  checked={columnsVisibilityCompany.id}
                  onChange={() => handleCheckboxChangeCompany("id")}
                />
                Company ID
              </label>
              <br />
              <label>
                <input
                  className="mr-2"
                  type="checkbox"
                  checked={columnsVisibilityCompany.name}
                  onChange={() => handleCheckboxChangeCompany("name")}
                />
                Company Name
              </label>
              <br />
              <label>
                <input
                  className="mr-2"
                  type="checkbox"
                  checked={columnsVisibilityCompany.customer_name}
                  onChange={() => handleCheckboxChangeCompany("customer_name")}
                />
                Customer Name
              </label>

              <br />
              <label>
                <input
                  className="mr-2"
                  type="checkbox"
                  checked={columnsVisibilityCompany.gst_no}
                  onChange={() => handleCheckboxChangeCompany("gst_no")}
                />
                Gst Number
              </label>
              <br />
              <label>
                <input
                  className="mr-2"
                  type="checkbox"
                  checked={columnsVisibilityCompany.industry}
                  onChange={() => handleCheckboxChangeCompany("industry")}
                />
                Industry
              </label>
              <br />
              <label>
                <input
                  className="mr-2"
                  type="checkbox"
                  checked={columnsVisibilityCompany.created_at}
                  onChange={() => handleCheckboxChangeCompany("created_at")}
                />
                Create Date
              </label>
              <br />
              <label>
                <input
                  className="mr-2"
                  type="checkbox"
                  checked={columnsVisibilityCompany.payment_alert_date}
                  onChange={() =>
                    handleCheckboxChangeCompany("payment_alert_date")
                  }
                />
                Payment A.Date
              </label>
              <br />
              <label>
                <input
                  className="mr-2"
                  type="checkbox"
                  checked={columnsVisibilityCompany.freeze_date}
                  onChange={() => handleCheckboxChangeCompany("freeze_date")}
                />
                Freeze Date
              </label>
              <br />
              <label>
                <input
                  className="mr-2"
                  type="checkbox"
                  checked={columnsVisibilityCompany.terminate_date}
                  onChange={() => handleCheckboxChangeCompany("terminate_date")}
                />
                Terminate Date
              </label>
              <br />
              <label>
                <input
                  className="mr-2"
                  type="checkbox"
                  checked={columnsVisibilityCompany.orderbook_enabled}
                  onChange={() =>
                    handleCheckboxChangeCompany("orderbook_enabled")
                  }
                />
                OrderBook
              </label>
            </>
          )}
        </div>
        <div style={{ flex: 1, overflowY: "auto", marginTop: 16 }}>
          <DataTable
            data={rowData}
            columns={visibleColumnsCompany}
            onGridReady={onGridReady}
            showSummary
            getSummary={() => ({})}
            rowCountColumn="name"
          />
        </div>
        {bulkUpdateModalVisible && (
          <BulkUpdateModal
            onCancel={() => setBulkUpdateModalVisible(false)}
            onSubmit={handleBulkUpdate}
          />
        )}
      </div>
    </>
  );
}

export default CompaniesList;
